<script lang="ts">
  export let handleConfirmEvent!: any;

  const handleConfirm = (): void => {
    handleConfirmEvent();
  };
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">開通時工事費残債について</h1>
    </div>
  </div>
  <div class="shadow rounded bg-white border-t-2 border-green-400">
    <div class="flex-1 m-10">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>開通時の工事費を分割払とされている場合、割賦残債を解約月翌月に一括で請求させていただきます。</p>
          <p class="mt-4">
            例)
            開通時工事費(18,480円)を770円の24回払いの分割で支払っており、解約時点で10回分の支払いが完了している場合、残り14回分の10,780円は解約月翌月に一括で支払いいただくことになります
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-col justify-items-center items-center">
      <div class="flex-1 m-5 flex flex-col md:flex-row justify-items-center items-center">
        <button class="button-primary md:ml-5 mb-5" on:click={handleConfirm}> 確認 </button>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  p {
    @apply tracking-normal mb-1;
  }
  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
